<script>
import axios from "axios";
import CashflowFilters from "./cashflow-filters.vue";

function initialFiltersState() {
  return {
    debts: false,
    expenses: false,
    paid: false,
    unpaid: false,
    pending: false,
    receipt: false,
    waiting_receive_payment: false,
    payment_method: "",
    expense_category: ""
  };
}

export default {
  components: { CashflowFilters },
  data: function() {
    return {
      payments: [],
      resume: {},
      appliedFilters: [],
      dataSet: null,
      page: 1,
      loading: true,
      dates: {
        start: moment().startOf("day"),
        end: moment().endOf("day")
      },
      order: "desc",
      exportLinkDisabled: false,
      filters: initialFiltersState()
    };
  },
  computed: {
    orderClass() {
      return `table-order-indicator-${this.order}`;
    },
    xlsxUrl() {
      return `/financial/cashflow.xlsx?${this.urlParams()}`;
    },
  },
  filters: {
    truncate: function(text, length, clamp) {
      clamp = clamp || "...";
      return text.length > length ? text.slice(0, length) + clamp : text;
    }
  },
  mounted() {
    const url = new URL(window.location.href);

    const startDate = url.searchParams.get("by_date[start]");
    const endDate = url.searchParams.get("by_date[end]");
    if (startDate) {
      this.dates.start = moment(startDate);
      this.dates.end = moment(endDate);
    }

    const page = url.searchParams.get("page");
    if (page) {
      this.page = page;
    }

    const order = url.searchParams.get("order");
    if (order) {
      this.order = order;
    }

    this.fetch();
  },
  methods: {
    formatAccountExpiration(value, paid_at) {
      if (!value) return;
      if (moment().diff(value, "days") > 0 && !paid_at) {
        // expired
        return "payment-expired";
      }
      if (moment().isSame(value, "days") && !paid_at) {
        // expires today
        return "payment-today";
      }
      return;
    },
    urlParams(page = 1) {
      let params = new URLSearchParams();

      params.append("by_date[start]", this.dates.start.format());
      params.append("by_date[end]", this.dates.end.format());
      Object.keys(this.filters).forEach(key => {
        params.append(key, this.filters[key]);
      });

      if (this.page > 1) {
        params.append("page", this.page);
      }

      params.append("order", this.order);

      return params;
    },
    onDatesUpdated(e) {
      this.exportLinkDisabled = false;
      this.dates = e;
    },
    onDatesSubmited() {
      this.exportLinkDisabled = false;
      this.page = 1;
      this.fetch();
    },
    onFiltersUpdated(e) {
      this.exportLinkDisabled = false;
      Object.keys(e).forEach(v => {
        this.filters[v] = e[v];
      });
      this.page = 1;
    },
    changePage(page) {
      this.page = page;
      this.fetch();
    },
    fetch() {
      this.loading = true;
      axios
        .get(`/financial/cashflow.json?${this.urlParams()}`)
        .then(response => {
          this.dataSet = response.data.pagination;
          this.payments = response.data.data.payments;
          this.resume = response.data.data.resume;
          this.appliedFilters = response.data.data.appliedFilters;

          history.replaceState(
            null,
            null,
            `${location.pathname}?${this.urlParams()}`
          );
          this.loading = false;
        });
    },
    clearFilters() {
      this.$refs.filtersRef.clearFilters()
    },
    switchOrder() {
      this.order == "asc" ? (this.order = "desc") : (this.order = "asc");
      this.fetch();
    },
    exportCashflow() {
      this.exportLinkDisabled = true;
      axios
        .get(`/financial/cashflow/export?${this.urlParams()}`);
    }
  }
};
</script>
